// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__36_nM","label":"Radio_label__2W0ZT","checkMark":"Radio_checkMark__3NJgb","disabled":"Radio_disabled__1x3Tv"};